import createVueComponent from '../createVueComponent';

const Bold = createVueComponent('BoldIcon', [
  ['path', { d: 'M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z' }],
  ['path', { d: 'M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z' }],
]);

export default Bold;
